import { useCurrentDate } from "@sellar-io/components";
import {
  daysOfWeek,
  getNextCourierDispatchAndDeliveryDates,
} from "@sellar-io/common";
import dayjs from "dayjs";
import { ActionPanel } from "../../../components/actionPanel/ActionPanel";

export const CourierDeliveryScheduleActionPanel = ({
  orderCutOffTime,
  dispatchDaysAfterConfirmation,
  deliveryDaysAfterDispatch,
  selectedDays,
  className,
  startAt,
  allowSaturdayDelivery,
}: {
  orderCutOffTime: string;
  dispatchDaysAfterConfirmation: number;
  deliveryDaysAfterDispatch: number;
  selectedDays: daysOfWeek[];
  startAt: Date | null;
  className?: string;
  allowSaturdayDelivery: boolean;
}) => {
  const currentDate = useCurrentDate();
  const startDate =
    startAt && !isNaN(startAt.getTime()) ? startAt : currentDate;
  const response = getNextCourierDispatchAndDeliveryDates({
    orderCutOffTime,
    courierDaysSchedule: selectedDays.map((day) => ({
      day,
    })),
    dispatchDaysAfterConfirmation: parseInt(
      dispatchDaysAfterConfirmation.toString(),
    ),
    deliveryDaysAfterDispatch: parseInt(deliveryDaysAfterDispatch.toString()),
    startDateReference: startDate,
    allowSaturdayDelivery,
  });

  const orderDate = dayjs(startDate).format("DD/MM/YY");
  const dispatchDate = response
    ? response.estimatedDispatchDate.format("DD/MM/YY")
    : "";
  const deliveryDay = response
    ? response.estimatedDeliveryDate.format("DD/MM/YY")
    : "";

  if (!orderDate || !deliveryDay || !dispatchDate) return null;
  return (
    <ActionPanel title={""} className={className}>
      <p>
        For example, a buyer on your storefront right now would see that by
        ordering before <strong>{orderCutOffTime}</strong> on{" "}
        <strong>{orderDate}</strong>, the estimated delivery date would be{" "}
        <strong>{deliveryDay}</strong>
      </p>
    </ActionPanel>
  );
};
